import { t } from '../../i18n.js';
import { bindPasswordToggles } from '../../utils/formHelpers';

export default function bookingResetPassword({
                                                 $,
                                                 state,
                                                 data,
                                                 routes,
                                                 emit,
                                                 sharedState,
                                                 onNext,
                                                 onComplete,
                                                 onSaveState
                                             }) {
    function render() {
        const $el = $(`
<div class="booking-reset-password-row active" data-auth-step="booking-reset-password">
        <button class='login-close-button'>&times;</button>
        <form class="booking-reset-password-form">
            <div class="form-row">
                <label for="bookingResetPassword">${t('new_password')}</label>
                <input id="bookingResetPassword" type="password"/>
                <p class="field-error field-password-length-error" style="display:none;">${t('password_must_have_at_least_6_characters')}</p>
            </div>
            <div class="form-row">
                <label for="bookingConfirmResetPassword">${t('confirm_new_password')}</label>
                <input id="bookingConfirmResetPassword" type="password"/>
                <p class="field-error field-password-length-error" style="display:none;">${t('password_must_have_at_least_6_characters')}</p>
            </div>
            <div class="form-actions">
                <button type="submit">${t('reset_password')}</button>
            </div>
        </form>
    </div>        `);

        bindPasswordToggles($el); // FB-031: parola noua + confirmarea
        return $el;
    }

    return {render};
}